import Image from 'next/image';
import cn from 'classnames';

import xCircle from 'public/static/images/global/icons/x-circle.svg';
import checkCircle from 'public/static/images/global/icons/check-circle.svg';

import s from './after-scale.module.css';

const AfterScale = ({ children, before = [], after = [] }) => (
  <>
    <div className="grid lg:grid-cols-2 gap-y-16 gap-x-8">
      <div className="flex flex-col">
        <p className="text-silver text-3.5xl sm:text-4xl lg:text-5xl font-aeonik mb-8 sm:mb-10">
          Before Scale
        </p>
        <div className="border flex-1 flex flex-col border-tundora rounded-2xl py-6 px-4 md:px-[30px] space-y-4">
          {before.map(item => (
            <div className="bg-gray-800 items-center rounded-2xl px-4 py-6 md:px-8 md:py-6 flex-1 flex space-x-[10px] md:space-x-4">
              <Image src={xCircle} alt="check" />
              <p className="text-silver xl:text-xl flex">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
      <div>
        <div className="flex items-center mb-10">
          <span className="flex lg:hidden">
            <Image src="/static/images/icons/scale.svg" width={27} height={27} />
          </span>
          <span className="hidden lg:block">
            <Image src="/static/images/icons/scale.svg" width={45} height={45} />
          </span>
          <p className="text-3.5xl ml-6 md:ml-8 sm:text-4xl lg:text-5xl whitespace-nowrap flex-1 text-white">
            After <span className="text-gradient font-aeonik mb-10">Scale</span>
          </p>
        </div>
        <div className={cn('flex flex-col', s['after-scale--box'])}>
          <div className="bg-black rounded-2xl py-6 px-4 md:px-[30px] space-y-4">
            {after.map(item => (
              <div className="bg-white rounded-2xl px-4 py-6 md:px-8 md:py-6 flex space-x-[10px] md:space-x-4">
                <Image src={checkCircle} alt="check" />
                <p className="text-black xl:text-xl flex-1">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    <div className="mt-16">{children}</div>
  </>
);

export default AfterScale;
